export default {
  props: {
    data: { type:Array, default: () => ([]) }
  },
  data: () => ({
    columns: [
      {label: '粉丝量级', width: '95px', key: 'name', align: 'center'},
      {label: '达人数', width: '45px', key: 'anchorCount', align: 'center'},
      {label: '场次数', width: '45px', key: 'liveCount', align: 'center'},
      {label: '商品数', width: '45px', key: 'commodityCount', align: 'center'},
      {label: '直播销量', width: '60px', key: 'saleVolume', align: 'center'},
      {label: '直播销售额', width: '70px', key: 'sales', align: 'center'},
    ],
  }),
  computed: {
    listData:(_this = this) => _this.$props.data?.map(ele => ({
      ...ele,
      name: ele?.key,
      anchorCount: _this.$retainWan(ele?.anchorCount,false,2,'--'),
      liveCount: _this.$retainWan(ele?.liveCount,false,2,'--'),
      commodityCount: _this.$retainWan(ele?.commodityCount,false,2,'--'),
      sales: _this.$retainWan(ele?.sales,false,2,'--'),
      saleVolume: _this.$retainWan(ele?.saleVolume,false,2,'--'),
    })),
    isEmpty: (_this = this) => !_this.listData?.length
  },
  methods: {
    parseStyle(width,textAlign){
      return {
        width,
        textAlign
      }
    }
  }
}
